import { render, staticRenderFns } from "./return.vue?vue&type=template&id=7e268548&scoped=true"
import script from "./return.vue?vue&type=script&lang=js"
export * from "./return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e268548",
  null
  
)

export default component.exports